import { Button } from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";
import "./EnableSsoButton.css";

interface EnableSsoButtonProps {
  status: "TEST" | "ENABLED" | "DISABLED";
  isHighlighted?: boolean;
  onEnable: () => void;
  isPending: boolean;
}

export default function EnableSsoButton({
  status,
  isHighlighted = false,
  onEnable,
  isPending,
}: EnableSsoButtonProps) {
  const intl = useIntl();

  if (status !== "TEST") {
    return null;
  }

  return (
    <div
      className={`EnableSsoButton${isHighlighted ? " EnableSsoButton--highlighted" : ""}`}
    >
      <Button
        kind="filled"
        size="medium"
        onClick={onEnable}
        isLoading={isPending}
        aria-label={intl.formatMessage({
          id: "eZTbfC",
          defaultMessage: "Enable SSO",
          description: "Aria label for enable SSO button",
        })}
      >
        <FormattedMessage
          id="3aq7l1"
          defaultMessage="Enable SSO"
          description="Button label to enable SSO for all users"
        />
      </Button>
    </div>
  );
}
